export const useAuth = () => {
  // write logic to check whether user is logged in or not using token
  return localStorage.getItem('auth_token');
};
